/**------------------------------------------------------
 * Environment Types
 */
export enum EnumEnvironment {
	Production 	= 'production',
	Development = 'development',
	Local 		= 'local'
}
